const VOLATILITIES = [1, 2, 3, 4, 5, 6];

const isValidVolatility = (volatility?: number) =>
  VOLATILITIES.includes(volatility ?? -1);

export default isValidVolatility;
